<template>
  <Layout>
    <DataBox :loading="loading" :error="error">
      <UiPageTitle title="Редактирование сотрудника" :back-link="{ name: 'managers' }" />

      <div class="row">
        <div class="col-xs-12 col-sm-6"><ManagerInfo /></div>
        <div class="col-xs-12 col-sm-6"><ManagerAccesses /></div>
      </div>
    </DataBox>
  </Layout>
</template>

<script>
import Layout from '@/layout/inside/index.vue'
import ManagerInfo from './managerInfo/ManagerInfo.vue'
import ManagerAccesses from './managerAccesses/ManagerAccesses.vue'

import UiPageTitle from '@/components/UiPageTitle.vue'

import DataBox from '@/components/DataBox.vue'

import { ManagersService } from '@/services/managers.service'
import { redirectIfDenied } from '@/services/ability.service'

export default {
  page: {
    title: 'Редактирование сотрудника',
  },
  components: {
    Layout,
    ManagerInfo,
    ManagerAccesses,
    UiPageTitle,
    DataBox,
  },
  data() {
    return {
      loading: false,
      error: false,
    }
  },
  mounted() {
    this.getManagerById()
  },
  methods: {
    /**
     * Send request to backend for get data manager by id .
     * Then run mutation `SET_CURRENT_MANAGER` in vuex.
     *
     * @returns {Object} data Response wrapper. Contains data of `Manager`.
     * */
    async getManagerById() {
      this.loading = true
      try {
        const managerId = this.$route.params.id

        const { data } = await ManagersService.getById({ id: managerId })

        this.$store.commit('managers/SET_CURRENT_MANAGER', { ...data })
      } catch (error) {
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
        this.error = error

        redirectIfDenied.call(this, error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
